goog.provide("shadow.js.shim.module$src$svg$weather$cloud_arrow_up_svg$default");
shadow.js.shim.module$src$svg$weather$cloud_arrow_up_svg$default = shadow.js.shim.module$src$svg$weather$cloud_arrow_up_svg.default;
